import PropTypes from 'prop-types';
import type { MessageDescriptor } from 'react-intl';
import type { Nullable } from '../../../types/helpers';
import type { RawUrl } from '../../../utils/api';

export interface FooterLink {
    id: number;
    url?: string;
    title: MessageDescriptor;
    label: MessageDescriptor;
    dataTestId?: Nullable<string>;
    componentId?: Nullable<string>;
    showInNewTab?: Nullable<boolean>;
}

export type RawFooterLink = FooterLink & {
    url: RawUrl;
};

export type ResolvedFooterLink = FooterLink & {
    url: string;
    isPwaLink: boolean;
};

export interface LinkGroupProps {
    title: MessageDescriptor;
    links: ResolvedFooterLink[];
    containerDataTestId?: string;
    headerDataTestId?: string;
}

export type LinksToRetrieve = { id: number; url: RawUrl };

export const MessageDescriptorPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.arrayOf(
            PropTypes.shape({
                type: PropTypes.number.isRequired,
                value: PropTypes.string.isRequired,
            }).isRequired,
        ).isRequired,
    ]).isRequired,
});
